export default __webpack_public_path__ + "static/react-9e75b3e121dc3bf16f00de8de78df6f9.png";